import { render, staticRenderFns } from "./ArtistMatch.vue?vue&type=template&id=094aaf94&scoped=true"
import script from "./ArtistMatch.vue?vue&type=script&lang=js"
export * from "./ArtistMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094aaf94",
  null
  
)

export default component.exports